import React from 'react';

class WhatIfCalcPageMain extends React.Component {
  render(){
    return(
      <div>
        What if calc page
      </div>
    );
  }
}

export default WhatIfCalcPageMain
